import type { QueryClient } from "@tanstack/react-query";
import { acknowledgeRecoveryCodes } from "./api/passkeys.api";

export const pendingRecoveryCodesGenerationKey = [
  "mfa",
  "pending-recovery-codes-generation",
] as const;

export function parkRecoveryCodesGeneration(queryClient: QueryClient, generation: number): void {
  if (!Number.isInteger(generation) || generation < 1) return;
  queryClient.setQueryDefaults(pendingRecoveryCodesGenerationKey, {
    gcTime: Infinity,
    staleTime: Infinity,
  });
  queryClient.setQueryData(pendingRecoveryCodesGenerationKey, generation);
}

export function clearPendingRecoveryCodesGeneration(queryClient: QueryClient): void {
  queryClient.removeQueries({ queryKey: pendingRecoveryCodesGenerationKey });
}

export function readPendingRecoveryCodesGeneration(queryClient: QueryClient): number | null {
  const value = queryClient.getQueryData<number | null>(pendingRecoveryCodesGenerationKey);
  if (typeof value !== "number" || !Number.isInteger(value) || value < 1) return null;
  return value;
}

export async function ackRecoveryCodesShown(
  queryClient: QueryClient,
  generation?: number | null,
): Promise<void> {
  let token = generation;
  if (typeof token !== "number" || !Number.isInteger(token) || token < 1) {
    token = readPendingRecoveryCodesGeneration(queryClient);
  }
  if (typeof token !== "number" || !Number.isInteger(token) || token < 1) return;
  try {
    await acknowledgeRecoveryCodes(token);
  } catch {
    return;
  }
}
